// extracted by mini-css-extract-plugin
module.exports =  {"main":"---src-components-UserManagement-EditUserDialog__main--XBhjx"};